import React from 'react';
import { Check } from 'lucide-react';

const WizardStep = ({
    currentStep,
    totalSteps,
    title,
    subtitle,
    children,
    onNext,
    onBack,
    nextLabel = 'Next',
    backLabel = 'Back',
    isNextDisabled = false,
    showSteps = true
}) => {
    return (
        <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl overflow-hidden flex flex-col max-h-[90vh]">
            {/* Header */}
            <div className="p-8 border-b border-gray-100 bg-white sticky top-0 z-10">
                {showSteps && (
                    <div className="flex items-center justify-between mb-8">
                        {Array.from({ length: totalSteps }).map((_, index) => {
                            const stepNum = index + 1;
                            const isCompleted = stepNum < currentStep;
                            const isCurrent = stepNum === currentStep;

                            return (
                                <div key={index} className="flex items-center flex-1 last:flex-none">
                                    <div className={`
                                        flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold transition-all
                                        ${isCompleted ? 'bg-green-500 text-white' : isCurrent ? 'bg-primary text-white' : 'bg-gray-100 text-gray-400'}
                                    `}>
                                        {isCompleted ? <Check size={16} /> : stepNum}
                                    </div>
                                    {index < totalSteps - 1 && (
                                        <div className={`flex-1 h-1 mx-4 rounded-full ${isCompleted ? 'bg-green-500' : 'bg-gray-100'}`} />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                <h2 className="text-2xl font-bold text-gray-900 mb-2">{title}</h2>
                <p className="text-gray-500">{subtitle}</p>
            </div>

            {/* Content - Scrollable */}
            <div className="flex-1 overflow-y-auto p-8">
                {children}
            </div>

            {/* Footer */}
            <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end gap-3 rounded-b-2xl">
                {onBack && (
                    <button
                        onClick={onBack}
                        className="px-6 py-2.5 text-gray-600 font-medium hover:bg-gray-200 rounded-xl transition-colors"
                    >
                        {backLabel}
                    </button>
                )}
                <button
                    onClick={onNext}
                    disabled={isNextDisabled}
                    className={`
                        px-8 py-2.5 bg-gradient-to-r from-primary to-primary-hover text-white rounded-xl font-semibold shadow-lg 
                        shadow-primary/30 hover:shadow-xl hover:shadow-primary/40 transition-all
                        ${isNextDisabled ? 'opacity-50 cursor-not-allowed grayscale' : ''}
                    `}
                >
                    {nextLabel}
                </button>
            </div>
        </div>
    );
};

export default WizardStep;
